import React, {PureComponent} from 'react';
import {injectIntl} from 'react-intl';
import InputTel from '@homeaway/react-input-tel';
import {DebounceInput} from 'react-debounce-input';
import {pick} from 'lodash';

import {ERROR_PHONE, PHONE_NUM_LABEL, COUNTRY_CODE_LABEL} from '../../../utils/constants';

const telephoneLabels = {
    phoneNumnerLabel: {
        id: 'giftCardPhoneNumberText',
        defaultMessage: PHONE_NUM_LABEL
    },
    countryCodeLabel: {
        id: 'giftCardCountryCodeText',
        defaultMessage: COUNTRY_CODE_LABEL
    },
    invalidPhoneError: {
        id: 'giftCardFormPhoneErrorMessage',
        defaultMessage: ERROR_PHONE
    }
};

class TelephoneNumber extends PureComponent {
    state = {
        errorMsg: '',
        phoneNumber: '',
        countryCode: 'us',
        labels: {
            phoneNumber: this.props.intl.formatMessage(telephoneLabels.phoneNumnerLabel),
            countryCode: this.props.intl.formatMessage(telephoneLabels.countryCodeLabel)
        },
        showCountrySelect: true
    };
    handlePhoneFocus = () => {
        this.setState({errorMsg: ''}); // clear on focus
    }

    updatePhoneReduxForm = (values) => {
        const stateObj = pick(this.state, ['phoneNumber', 'countryCode']);
        this.props.input.onChange({...stateObj, ...values});
    }

    handlePhoneBlur = (event, phone) => {
        const phoneNum = phone.raw;
        if (!phoneNum || !phone.isValid) {
            this.setState({errorMsg: ERROR_PHONE});
        }
        if (phoneNum !== this.state.phoneNumber) { // to handle the cases of autofill
            const phoneObjToUpdate = {phoneNumber: phoneNum};
            this.setState(phoneObjToUpdate);
            this.updatePhoneReduxForm(phoneObjToUpdate);
        }
    }

    handlePhoneChange = (e, phoneObject) => {
        if (phoneObject.raw !== this.state.phoneNumber) {
            const phoneObjToUpdate = {phoneNumber: phoneObject.raw};
            this.setState(phoneObjToUpdate);
            this.updatePhoneReduxForm(phoneObjToUpdate);
        }
    }

    handleCountryCodeChange = (e, countryData) => {
        if (countryData.cc !== this.state.countryCode) {
            const countryCodeObjToUpdate = {countryCode: countryData.cc};
            this.setState(countryCodeObjToUpdate);
            this.updatePhoneReduxForm(countryCodeObjToUpdate);
        }
    }

    getErrorText= () => {
        const {errorMsg} = this.state;
        const {error} = this.props.meta;
        return (error || errorMsg) && this.props.intl.formatMessage(telephoneLabels.invalidPhoneError);
    }

    render() {
        return (
            <DebounceInput
                debounceTimeout={300}
                element={InputTel}
                {...this.state}
                onPhoneChange={this.handlePhoneChange}
                onCountryCodeChange={this.handleCountryCodeChange}
                errorMsg={this.getErrorText()}
                onPhoneFocus={this.handlePhoneFocus}
                onPhoneBlur={this.handlePhoneBlur}
            />
        );
    }
}

export default injectIntl(TelephoneNumber);
